export const simulationFunnelFixture = (campaignId) => ({
  id: Number(campaignId) || 27,
  available: true,
  phase: 'collecting',
  vector: 'dataEntry',
  fileFormat: null,
  delivered: 232,
  scheduled: 240,
  opened: 168,
  clicked: 16,
  dataSubmitted: 4,
})
